<button
  tuiIconButton
  type="button"
  class="categories-button"
  iconStart="@tui.layout-grid"
  appearance="lp-icon-block"
  [size]="size"
  (click)="openCategoriesDialog(dialogTmp)"
></button>

<ng-template #dialogTmp>
  <div class="dialog">
    <div class="dialog__header">
      <div class="text_heading-6">
        {{ 'components.categoriesButton.labels.categories' | translate }}
      </div>

      <app-link [pseudo]="true" (click)="openFavoriteCategoriesDialog()">
        {{ 'components.categoriesButton.buttons.setCategories' | translate }}
      </app-link>
    </div>

    <div class="dialog__content">
      <!-- Категория "Новые" -->
      <lp-category-cell
        *ngIf="allowActiveCollectionsViewing"
        [category]="newCategoryItem"
        [withBackground]="true"
      ></lp-category-cell>

      <!-- Категории -->
      <lp-category-cell
        *ngFor="let category of categories"
        [category]="category"
        (cellClick)="onSelectMainCategory($event)"
      ></lp-category-cell>
    </div>
  </div>
</ng-template>
